<template>
  <el-dialog width="50%" :title="this.currentAction.name + ' ' + $t('c.notice.notice')" :visible.sync="showDialog"
    @close="closeDialog" :before-close="beforeClose" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag>
    <el-form ref="formRef" :rules="formRules" :model="formModel" :disabled="currentAction.value >= 3" label-width="144px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('c.notice.originator')" prop="originator">
            <el-input v-model="formModel.originator" maxlength="90" :placeholder="$t('c.form.maximumLength') + '90'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.notice.title')" prop="title">
            <el-input v-model="formModel.title" maxlength="90" :placeholder="$t('c.form.maximumLength') + '90'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.notice.message')" prop="message">
            <el-input v-model="formModel.message" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea" maxlength="800" :placeholder="$t('c.form.maximumLength') + '800'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="currentAction.value !== 4">
          <el-form-item :label="$t('c.notice.receivers')" prop="receivers">
            <el-select v-model="formModel.receivers" multiple :multiple-limit="receiversMultipleLimit" filterable :placeholder="$t('c.form.pleaseSelect')">
              <el-option
                v-for="item in receiversOptions"
                :key="item.id"
                :label="item.fullName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('c.notice.effectiveDate')" prop="startDate">
            <el-date-picker type="date" :placeholder="$t('c.form.pleaseSelect')" value-format="yyyy-MM-dd" v-model="formModel.startDate"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="~" prop="endDate">
            <el-date-picker type="date" :placeholder="$t('c.form.pleaseSelect')" value-format="yyyy-MM-dd" v-model="formModel.endDate"></el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24" v-if="currentAction.value !== 4">
          <el-form-item :label="$t('c.notice.confirmReceived')" prop="confirmReceived">
            <el-input v-model.number="formModel.confirmReceived" type="number" disabled :placeholder="$t('c.form.pleaseInput')"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24" v-if="currentAction.value !== 4">
          <el-form-item :label="$t('c.notice.extra')" prop="extra">
            <el-input v-model="formModel.extra" autosize type="textarea" maxlength="800" :placeholder="$t('c.form.maximumLength') + '800'"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="24" v-if="currentAction.value !== 4">
          <el-form-item :label="$t('c.notice.status')" prop="status">
            <el-radio-group v-model="formModel.status">
              <el-radio v-for="item in statusDicts" :key="item.itemCode" :label="item.itemCode">
                {{item.value}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="currentAction.value < 3" @click="saveForm()" type="primary">{{ $t('c.dialog.save') }}</el-button>
      <el-button @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  selectCountNotice,
  insertNotice,
  updateAllColumnNotice
} from '../../api/sys/Notice';
export default {
  // 组件属性对象
  props: {
    receiversOptions: Array,
    statusDicts: Array,
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    // 来自父组件的操作类型参数
    actionOfParent: Object,
    // 当前主表行记录
    currentTableRow: Object
  },
  // 组件数据对象
  data() {
    return {
      // select控件最多选择项数量控制
      receiversMultipleLimit: 10,
      showDialog: true,
      // 表单模型
      formModel: {},
      // 当前操作类型, ACTION.NEW/ACTION.VIEW/ACTION.EDIT
      currentAction: {},
      // 表单验证规则
      formRules: {
        originator: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        title: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        message: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        delete_this_line: []
      }
    };
  },
  // 页面首次加载数据
  mounted() {
    this.formModel = Object.assign({}, this.currentTableRow);
    this.currentAction = this.actionOfParent;
    if (!(this.formModel.receivers instanceof Array)) {
      // 将逗号分隔的多选值字符串转换为数组与多选控件关联
      this.$set(this.formModel, 'receivers', this.formModel.receivers ? this.formModel.receivers.split(',') : []);
    }
  },
  methods: {
    /**
     * 保存表单
     */
    saveForm() {
      this.$refs
        .formRef.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'error',
              message: this.$t('c.form.formMissInfo')
            });
            return;
          }
          // 表单校验成功
          if (this.currentAction.value === 1) {
            this.insert();
          } else {
            this.updateAllColumn();
          }
        });
    },
    /**
     * 新增插入记录
     */
    insert() {
      selectCountNotice({
        title: this.formModel.title
      }).then(result => {
        if (result.data > 0) {
          this.$message({
            type: 'error',
            message: this.$t('c.form.the') + this.$t('c.notice.title') + ' [' + this.formModel.title + '] ' + this.$t('c.form.alreadyExists')
          });
          return;
        }
        this.formModel.receivers = this.formModel.receivers.join(',');
        insertNotice(this.formModel).then(result => {
          if (result.code === 20000) {
            this.closeDialog(true);
          }
        });
      });
    },
    /**
     * 全部字段覆盖更新
     */
    updateAllColumn() {
      if (this.isModifiedOfUnique()) {
        selectCountNotice({
          title: this.formModel.title
        }).then(result => {
          if (result.data > 0) {
            this.$message({
              type: 'error',
              message: this.$t('c.form.the') + this.$t('c.notice.title') + ' [' + this.formModel.title + '] ' + this.$t('c.form.alreadyExists')
            });
            return;
          }
          this.formModel.receivers = this.formModel.receivers.join(',');
          updateAllColumnNotice(this.formModel).then(result => {
            if (result.code === 20000) {
              this.closeDialog(true);
            }
          });
        });
        return;
      }
      this.formModel.receivers = this.formModel.receivers.join(',');
      updateAllColumnNotice(this.formModel).then(result => {
        if (result.code === 20000) {
          this.closeDialog(true);
        }
      });
    },
    /**
     * 有唯一索引的属性是否被修改过
     * @returns boolean true表示修改过 false表示未被修改
     */
    isModifiedOfUnique() {
      return this.currentTableRow.title !== this.formModel.title;
    },
    /**
     * 关闭对话框
     * @param modified 是否有更新
     */
    closeDialog(modified) {
      if (this.beforeCloseCheck()) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
        if (modified) {
          this.$emit('listenToDetailDialogClose', this.currentAction)
        }
      }
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    }
  }
};
</script>

<style lang="scss">
</style>
